import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-292bc10c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-close" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "d-flex align-center logo",
  style: {"padding":"0 20px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    height: "50",
    src: "https://i0.wp.com/www.freewater.io/wp-content/uploads/2022/05/Logo_Freewater_Vert_Color-1.png?fit=2560%2C2560&ssl=1",
    alt: "Logo here"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", null, "Coming Soon")
], -1))
const _hoisted_5 = { class: "flat-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass({ 'scrolled': _ctx.isScrolled, 'isOpen': _ctx.isOpen })
  }, [
    _createElementVNode("ul", null, [
      _createElementVNode("button", {
        class: "close-btn flat-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = false))
      }, _hoisted_2),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/advertise" }, {
          default: _withCtx(() => [
            _createTextVNode("Advertise")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/distribute" }, {
          default: _withCtx(() => [
            _createTextVNode("Distribute")
          ]),
          _: 1
        })
      ]),
      _hoisted_3,
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/faq" }, {
          default: _withCtx(() => [
            _createTextVNode("FAQ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/contactus" }, {
          default: _withCtx(() => [
            _createTextVNode("Contact us")
          ]),
          _: 1
        })
      ]),
      _hoisted_4
    ]),
    _createElementVNode("button", _hoisted_5, [
      _createElementVNode("i", {
        class: "fa fa-bars",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = true))
      })
    ])
  ], 2))
}